const MapsKey = "AIzaSyCYEQt2l5v6feMl4LkdK9YK7YyD_ezwYeU";

const PlacesKey = "AIzaSyCYEQt2l5v6feMl4LkdK9YK7YyD_ezwYeU";

export {MapsKey, PlacesKey};